import {inlineError} from '@s-ui/decorators'
import {Service} from '@s-ui/domain'

export class GetTagcloudSeoService extends Service {
  /**
   * @constructor
   * @param {Object} deps
   * @param {Object} deps.mapperFactory
   * */
  constructor({
    config,
    fromMakesJsonToMakesListVOVehiclesMapper,
    fromModelsJsonToSubscriptionModelsListVOVehiclesMapper,
    fromListVOToTagcloudListVOSeoMapper,
    httpSeoRepository
  }) {
    super()
    this._config = config
    this._fromListVOToTagcloudListVOSeoMapper = fromListVOToTagcloudListVOSeoMapper
    this._fromMakesJsonToMakesListVOVehiclesMapper = fromMakesJsonToMakesListVOVehiclesMapper
    this._fromModelsJsonToSubscriptionModelsListVOVehiclesMapper =
      fromModelsJsonToSubscriptionModelsListVOVehiclesMapper
    this._httpSeoRepository = httpSeoRepository
  }

  @inlineError
  async execute({seoDataRequest}) {
    const {pageName} = seoDataRequest.toJSON()

    const {ADS_LIST_SUBSCRIPTION_PAGE_NAME, ADS_LIST_BUSINESS_SUBSCRIPTION_PAGE_NAME} = this._config.get('page')
    const rentingPageNames = [ADS_LIST_SUBSCRIPTION_PAGE_NAME, ADS_LIST_BUSINESS_SUBSCRIPTION_PAGE_NAME]
    if (rentingPageNames.includes(pageName)) {
      const bodyTypeId = seoDataRequest.get('bodyTypeId')
      const fuelTypeId = seoDataRequest.get('fuelTypeId')
      const makeId = seoDataRequest.get('makeId')
      const makes = seoDataRequest.get('makes')
      const models = seoDataRequest.get('models')
      const canonical = seoDataRequest.get('canonical')

      const makesListValueObject = this._fromMakesJsonToMakesListVOVehiclesMapper.map({makes})

      const modelsListValueObject = this._fromModelsJsonToSubscriptionModelsListVOVehiclesMapper.map({
        models
      })

      return this._fromListVOToTagcloudListVOSeoMapper.setParams({bodyTypeId, fuelTypeId, makeId, canonical}).map({
        makesListValueObject,
        modelsListValueObject
      })
    }

    return this._httpSeoRepository
      .getTagcloudSeo({
        seoDataRequest
      })
      .then(([error, tagcloudList]) => {
        if (error) {
          return Promise.reject(error)
        }

        return tagcloudList
      })
  }
}
